import { render, staticRenderFns } from "./ColumnChartDebt.vue?vue&type=template&id=d645d9c2&scoped=true&"
import script from "./ColumnChartDebt.vue?vue&type=script&lang=js&"
export * from "./ColumnChartDebt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d645d9c2",
  null
  
)

export default component.exports